import type {
  OrgCompassDeviceListItem,
  DashboardDeviceOverride,
} from "@/models/OrgCompassDevice/OrgCompassDeviceListItem";

const MILLIS_PER_SECOND = 1000;

function toEpochSeconds(iso: string): number {
  const parsed = Date.parse(iso);
  return Number.isNaN(parsed) ? 0 : Math.floor(parsed / MILLIS_PER_SECOND);
}

/**
 * Assembles the dashboard device override from a tapped device row so the
 * dashboard device block prefers this snapshot over the user's live ping.
 */
export function buildDeviceOverride(
  row: OrgCompassDeviceListItem,
): DashboardDeviceOverride {
  return {
    macAddress: row.mac_address,
    compassInfoSnapshot: {
      hardware_version: row.hardware_version,
      firmware_revision: row.firmware_revision,
      battery_percentage: row.battery_percentage,
      compass_alert_mute_status: row.compass_alert_mute_status,
      mac_address: row.mac_address,
      is_compass_core: row.is_compass_core,
      timestamp: toEpochSeconds(row.last_seen_at),
    },
    lastUserDisplayName: row.last_user_display_name ?? null,
    lastUserPhoneNumber: row.last_user_phone_number ?? null,
  };
}
